import { yupResolver } from "@hookform/resolvers/yup";
import { Alert, Box, Button, Grid, Paper, TextField, Typography } from "@mui/material";
import axios from 'axios';
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from 'react-router-dom';
import * as yup from "yup";
import { ifacSecurityURL } from '../../utility/apiURLS';

const Emailupdate = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [emailSent, setEmailSent] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  // Corrected: Retrieve userId as a string from localStorage
  const userId = localStorage.getItem("UserId");

  const schema = yup.object().shape({
    email: yup.string().email("Invalid email format").required("Email is required"),
  });

  const { register, handleSubmit, formState: { errors }, trigger } = useForm({
    resolver: yupResolver(schema)
  });

  const onSubmit = async (data) => {
    try {
      // Trigger email validation before making the update request
      await trigger('email');
  
      // Use the retrieved userId for the email update API
      const updateResponse = await axios.put(
        `${ifacSecurityURL}/api/GraphUserdetails/GetUserEmailUpdate/${userId}`,
        { id: userId, email: data.email }
      );
  
      console.log("Update Response:", updateResponse.data);
  
      // Check if the email update was successful
      if (updateResponse.status === 200) {
        // console.log("200 Status - Success Path Reached");
        window.alert("Email ID successfully updated");
        navigate('/login');
      } else {
        // console.log("Non-200 status or missing success flag.");
      }
      
    } catch (error) {
      setErrorMessage('An error occurred. Please try again later.');
      console.error("Error:", error);
    }
  };
  
  

  
  const handleClick = () => {
    navigate('/login');
  };

  return (
    <Paper sx={{ margin: '20px', paddingBottom: '10px', paddingRight: '10px', paddingLeft: '10px' }}>
      <Box mt={12} display="flex" flexDirection="column" alignItems="flex-start" >
        <Grid container spacing={2}>
          <Grid item xs={12} md={12}>
            <Typography color={'text.primary'} component={'label'} variant="h5">
              Email ID Update
            </Typography>
          </Grid>
          <form onSubmit={handleSubmit(onSubmit)} style={{ width: '100%', marginTop: '1rem' }}>
            <Grid container sx={{ display: "flex", justifyContent: "center" }}>
              <Grid item xs={3} md={1} style={{ marginTop: '20px', marginRight: '10px' }}>
                <Typography variant='h6' color={'text.primary'} component={'label'} >
                  Email ID
                  <Typography component={"span"} color={"error"}>*</Typography>
                </Typography>
              </Grid>
              <Grid item xs={4} md={4}>
                <TextField
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  id="email"
                  placeholder="Enter Your Email"
                  name="email"
                  autoComplete="email"
                  autoFocus
                  {...register("email")}
                  error={!!errors.email}
                  helperText={errors.email ? errors.email.message : ''}
                  onFocus={() => setErrorMessage('')}
                />
              </Grid>
            </Grid>

            <Grid item xs={12} md={12}>
              <Typography sx={{ margin: 2 }}>
                Enter your Email ID and click "Submit". An email with the subject "Reset Password" will be sent to your registered Email ID. Visit the link sent in this mail where you can set your new password.
              </Typography>
            </Grid>

            {errorMessage && (
              <Alert severity="error" sx={{ mt: 3, fontSize: '12px', fontWeight: '400', color: '#D31A21', alignItems: 'center' }}>
                <strong>{errorMessage}</strong>
              </Alert>
            )}

            {emailSent ? (
              <Grid container spacing={2} sx={{ display: "flex", justifyContent: "flex-end", alignItems: "flex-end" }}>
                <Alert severity="success" style={{ marginTop: '1rem' }}>
                  A reset link has been sent to your Email address.
                </Alert>
              </Grid>
            ) : (
              <Grid container spacing={2} sx={{ display: "flex", justifyContent: "flex-end", alignItems: "flex-end", marginRight: '5px' }}>
                <Grid item xs={3} md={2}>
                  <Button type="submit" fullWidth variant="contained" color="primary" style={{ marginTop: '1rem' }}>
                    Submit
                  </Button>
                </Grid>
                <Grid item xs={3} md={2}>
                  <Button onClick={handleClick} fullWidth variant="outlined" color="primary" style={{ marginTop: '1rem' }}>
                    Back
                  </Button>
                </Grid>
              </Grid>
            )}

          </form>
        </Grid>
      </Box>
    </Paper>
  );
};

export default Emailupdate;
